import { Component, OnInit, Inject, Injector } from '@angular/core';
import { DialogConfig, DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  FormValidatorService,
  ForgotPasswordService
} from '@tmhcc-ng-lib/content-service';
import { OktaConfig } from '@okta/okta-angular';
import { OKTA_CONFIG } from '@okta/okta-angular';
import {
  AppDataService,
  ChangePasswordEmailValidService
} from '@tmhcc-ng-lib/data-service';
import { forgotPasswordType } from '@tmhcc-ng-lib/data-service';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';

import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';
@Component({
  selector: 'ae-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  forgotPassword: FormGroup;
  submitted = false;
  sitecoreContent;
  isDataAvailable: boolean = false;
  validTime;
  formFields: any = {};
  email: string = '';

  constructor(
    public dialogData: DialogConfig,
    private fb: FormBuilder,
    public dialogService: DialogService,
    private forgotPasswordService: ForgotPasswordService,
    @Inject(OKTA_CONFIG) protected config: OktaConfig,
    private oktaLoginService: OktaLoginService,
    private injector: Injector,
    private appDataService: AppDataService,
    private formValidatorService: FormValidatorService,
    private changePasswordEmailValid: ChangePasswordEmailValidService
  ) {}

  ngOnInit(): void {
    this.changePasswordEmailValid.emailValid().subscribe(res => {
      this.validTime = res.ForgotPassword[0].EmailExpirationHours;
    });

    this.forgotPassword = this.fb.group(
      {
        // companyId: [''],
        email: [''],
        confirmEmail: ['']
      },
      {
        validator: this.formValidatorService.mustMatch('email', 'confirmEmail')
      }
    );

    this.forgotPasswordService.data$.subscribe(res => {
      this.forgotPassData(res.data[0]);
      // this.formFields.companyField = this.fetchFormFields(
      //   res.forms[0].fields,
      //   'Producer Company ID'
      // );
      this.formFields.emailField = this.fetchFormFields(
        res.forms[0].fields,
        'Email Address'
      );
      this.formFields.verifyEmailField = this.fetchFormFields(
        res.forms[0].fields,
        'Verify Email Address'
      );
      // const companyIdValidations = this.formValidatorService.setFormValidator(
      //   this.formFields.companyField
      // );
      const emailValidations = this.formValidatorService.setFormValidator(
        this.formFields.emailField
      );
      const verifyEmailValidations = this.formValidatorService.setFormValidator(
        this.formFields.verifyEmailField
      );
      // this.f.companyId.setValidators(companyIdValidations);
      this.f.confirmEmail.setValidators(verifyEmailValidations);
      // this.f.companyId['requiredError'] = this.fetchValidationValue(
      //   this.formFields.companyField.fieldInfo.validations,
      //   'Required'
      // ).value;
      this.f.email.setValidators(emailValidations);
      this.f.email['requiredError'] = this.fetchValidationValue(
        this.formFields.emailField.fieldInfo.validations,
        'Required'
      ).value;
      this.f.email['validEmailError'] = this.fetchValidationValue(
        this.formFields.emailField.fieldInfo.validations,
        'EmailValid'
      ).value;
      this.f.confirmEmail['matchError'] = this.fetchValidationValue(
        this.formFields.verifyEmailField.fieldInfo.validations,
        'VerifyEmailMatch'
      ).value;
      this.f.confirmEmail['requiredError'] = this.fetchValidationValue(
        this.formFields.verifyEmailField.fieldInfo.validations,
        'Required'
      ).value;
    });
  }

  fetchValidationValue(validations: any[], key: string) {
    const filterObj = validations.filter(ele => ele.key == key);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }

  fetchFormFields(fields: any[], label: string) {
    const filterObj = fields.filter(ele => ele.fieldInfo.label == label);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }

  forgotPassData(data) {
    if (data) {
      this.sitecoreContent = data;
      this.isDataAvailable = true;
      this.dialogData.modalSetting.title = this.sitecoreContent.title;
    }
  }
  get f() {
    return this.forgotPassword.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.forgotPassword.invalid) {
      return;
    } else {
      this.email = this.forgotPassword.value.email;
      const dataCall: forgotPasswordType = {
        // agencyid: this.forgotPassword.value.companyId,
        email: this.forgotPassword.value.email
      };
      this.oktaLoginService.forgotPassword(dataCall).subscribe(res => {
        if (res) {
          this.dialogService.close();
          const notifier = this.injector.get(AlertTosterService);
          notifier.success(
            'An email for recovering your password has been sent.'
          );
        }
      });
    }
  }
  cancel() {
    this.dialogService.close();
  }
}
